import { useEffect, useState } from "react";
import Button from "../buttons/Button";
import style from "./Card.module.css";

const Card = (props) => {
  const [ctas, setCtas] = useState([]);

  useEffect(() => {
    if (props.ctas) {
      setCtas(props.ctas);
    }
  }, [props.ctas]);

  return (
    <div
      className={`${style.card} ${
        props.variants ? props.variants.map((i) => style[i]).join(" ") : null
      }`}
    >
      {props.image ? <div className={style.image}><img src={props.image} /></div> : null}
      <div className={style.details}>
        <h2>{props.title}</h2>
        {props.text}
      </div>
      <div className={style.ctas}>
        {ctas.map((cta, index) => (
          <Button
            key={index}
            preIcon={cta.icon}
            variants={["text"]}
            onClick={cta.onClick}
          >
            {cta.name}
          </Button>
        ))}
      </div>
    </div>
  );
};

export default Card;
